import React from "react";
import { Routes, Route } from "react-router-dom";

import UserManagement from "../component/UserManagement";

const UserManagementRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<UserManagement />} />
    </Routes>
  );
};

export default UserManagementRoutes;
